import { aiStyles as e, glassPill as t } from "../../theme/theme.mjs";
import { css as n, styled as r } from "styled-components";
//#region src/components/Composer/Composer.styled.ts
var i = r.div`
    display: flex;
    align-items: flex-end;
    gap: ${({ theme: e }) => e.spacing(.5)};
    ${t};
    border-radius: 30px;
    padding: ${({ theme: e }) => e.spacing(.75, .75, .75, 1.5)};
    transition:
        border-color ${({ theme: e }) => e.transitions.fast},
        box-shadow ${({ theme: e }) => e.transitions.fast};

    ${({ $tone: t, theme: r }) => t === "ai" ? n`
                  &:focus-within {
                      border-color: transparent;
                      ${e.border};
                  }
              ` : n`
                  &:focus-within {
                      border-color: ${r.colors.ring};
                  }
              `}
`;
//#endregion
export { i as Capsule };
